import React from "react";
import { CustomButton, CustomTooltip } from "../../../../common/components";
import styles from "./MenuButton.module.css";

export default function MenuButton({ children = "", id = "", selected = false, onClick = null }) {
	return (
		<CustomButton
			disableRipple
			className={`${styles.menuButton} ${selected && styles["menuButton--selected"]}`}
			color="secondary"
			id={id}
			onClick={onClick}
		>
			<CustomTooltip showWhenOverflow placement="bottom-start" title={children || ""}>
				<span className={styles["menuButton__text--crop"]}>{children}</span>
			</CustomTooltip>
		</CustomButton>
	);
}
